import React from 'react';
import { auth } from '../firebase.js';

import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SingnOut = () => {
  return (
    <div className='header'>
      <h3>チャットボットに質問する</h3>
      <IconButton style={{ color: "white"}} onClick={() => auth.signOut()}>
        <CloseIcon />
      </IconButton>
    </div>
  )
}

export default SingnOut
